/* eslint-disable react/prop-types */

import React from 'react';
import { Badge } from 'rsuite';
import styled from 'styled-components';

const StyledBadge = styled.span`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  background-color: ${(props) => {
    switch (props.variant) {
      case 'ativo':
      case 'success':
        return '#4caf50';
      case 'inativo':
      case 'inactive':
        return '#9e9e9e';
      case 'aula':
      case 'lesson':
        return '#2196f3';
      case 'quiz':
        return '#9c27b0';
      case 'warning':
        return '#ff9800';
      case 'error':
        return '#f44336';
      default:
        return '#9e9e9e';
    }
  }};
  color: #fff;
`;

const StatusBadge = ({ variant, children }) => {
  return <StyledBadge variant={variant}>{children}</StyledBadge>;
};

export default StatusBadge;
